<script setup lang="ts"></script>
<template>
  <p class="text-[18px] text-lg text-[#7E8597]">
    <slot></slot>
  </p>
</template>
